export class ButtonConfigModal {
    showAddButton: boolean = true
    showExportButton: boolean = true
}